import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../auth/auth.service';

/**
 * Functional guard to enforce password change if required by the system.
 */
export const changePasswordGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isChangePasswordPath = route.routeConfig?.path === 'change-password';

  if (authService.isAuthenticated()) {
    const mustChange = authService.mustChangePassword();

    if (mustChange && !isChangePasswordPath) {
      // Needs change but not on the page -> force redirect to /change-password
      return router.createUrlTree(['/change-password']);
    }

    if (!mustChange && isChangePasswordPath) {
      // Doesn't need change but is on /change-password -> redirect to /home
      return router.createUrlTree(['/home']);
    }
  }

  return true;
};
